import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from '@tmapy/redux';
import { useMessage } from '@tmapy/intl';

import { Link } from '../link';
import { linkMessages } from '../linkMessages';
import type { RouteId } from '../routes';
import { setMenuRouteFilterId } from '../redux/menu/actions';

export type FilterLinkProps = {
  id: string;
  to: RouteId;
  filter?: Record<string, string | number | string[]>;
  label?: string;
};

export const FilterLink: React.FC<FilterLinkProps> = ({ id, to, filter, label }) => {
  const dispatch = useDispatch();
  const formatMessage = useMessage();
  const menuRouteFilterId = useSelector((state) => state.menu.menuRouteFilterId);
  // reserves the width of the bold (active) variant, see .dmx-menu--navItem in Menu.scss
  const text = label ?? formatMessage(linkMessages[to]);

  const handleClick = useCallback(() => {
    dispatch(setMenuRouteFilterId(id));
    if (!filter) return;

    switch (to) {
      default:
        return;
    }
  }, [filter]);

  return (
    <div
      className={classNames('dmx-menu--navItem', {
        'dmx-menu--navItem-isActive': id === menuRouteFilterId,
      })}
      data-label={text}
    >
      <Link to={to} onClick={handleClick}>
        {label}
      </Link>
    </div>
  );
};
